import { Loader } from 'components/Loader'
import { IconSvg } from '@prism/icon'
import { setCustomClick } from 'utils/analyticsUtils'
import { getWatchlistUrl } from 'utils/urlUtils'
import { Link } from 'components/Share/Link'

interface Iprops {
  loading: boolean
  count: number
}

export const WatchListCount = ({ loading, count }: Iprops) => {
  const watchlistUrl = getWatchlistUrl()

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Link
          className="navigation-link"
          onClick={() => setCustomClick('Watch List', { usePageName: true })}
          to={watchlistUrl}
        >
          <span className="right-action">
            <IconSvg glyph="eye" color="primary" />
            &nbsp;Watch List&nbsp;<b>({count ?? 0})</b>
          </span>
        </Link>
      )}
    </>
  )
}
